export const CREATE_BUCKET_UPLOAD = "CREATE_BUCKET_UPLOAD";
export const FETCH_BUCKET_UPLOAD = "FETCH_BUCKET_UPLOAD";
export const FETCH_BUCKET_UPLOADS = "FETCH_BUCKET_UPLOADS";
export const DELETE_BUCKET_UPLOAD = "DELETE_BUCKET_UPLOAD";
export const UPDATE_BUCKET_UPLOAD = "UPDATE_BUCKET_UPLOAD";
